import {Component, OnInit} from "@angular/core";
import {Router} from "@angular/router";
import {AuthService, provideEntityModel} from "@fedeltapointofsale/data-client";
import {AnalyticsService} from "../../analytics/analytics.service";
import {FUIAlertService} from "@fedeltapointofsale/ui";
import {UserProfileSummaryEntityModel} from "../user-profile-summary-entity.model";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {AnalyticEvent} from "../../analytics/analytic-event";
import {BehaviorSubject} from "rxjs";

@Component({
    selector: "wbo-user-profile-completion-page",
    templateUrl: "./user-profile-completion-page.component.html",
    styleUrls: ["./user-profile-completion-page.component.scss"],
    providers: [provideEntityModel(UserProfileSummaryEntityModel)]
})
export class UserProfileCompletionPageComponent implements OnInit {
    loaded: boolean = false;
    formGroup: FormGroup;

    constructor(private profileModel: UserProfileSummaryEntityModel,
                private router: Router,
                private authService: AuthService,
                private analyticsService: AnalyticsService,
                private alertService: FUIAlertService,
                private formBuilder: FormBuilder) {
        this.formGroup = this.formBuilder.group({
            email: ["", Validators.required],
            mobile: [""]
        });
        this.formGroup.get("email")["required$"] = new BehaviorSubject(true);
    }

    ngOnInit(): void {
        this.profileModel.loadEntity(undefined).then(() => {
            if (this.profileModel.data.employee.contact.email) {
                this.router.navigate([""]);
            } else {
                this.analyticsService.trackEvent(AnalyticEvent.USER_PROFILE_COMPLETION_REQUESTED);
                this.loaded = true;
            }
        }).catch(() => {
            this.router.navigate([""]);
        });
    }

    logout() {
        this.analyticsService.trackEvent(AnalyticEvent.USER_LOGOUT);
        this.authService.logout();
        this.router.navigate(["/login"]);
    }

    proceed() {
        Object.keys((this.formGroup.controls)).forEach((key) => {
            this.formGroup.controls[key].markAsTouched();
            this.formGroup.controls[key].updateValueAndValidity();
        });
        if (this.formGroup.valid) {
            if (this.profileModel.data.employee.contact.email) {
                this.analyticsService.trackEvent(AnalyticEvent.USER_PROFILE_COMPLETED);
                this.profileModel.saveEntity().then(() => {
                    this.router.navigate([""]);
                });
            }
        } else {
            this.alertService.showError(undefined, "wbo.user-profile-completion.message.emailRequired").subscribe(() => {
            });
        }
    }
}
